<template>
<div class="onlinePay onlinePay max-width">

	<div class='op_model'>

		<div class='op_mod_title font-16 color-prompt-deep'>
			<div>请尽快完成支付！</div>
			<div>【支付微信支付、支付宝支付】</div>
		</div>

		<div class='op_mod_qr'>
			<!-- 二维码 -->
			<div class='op_mod_qr_code'>
				<img class='op_mod_qr_code_img' :src='codeUrl' />
			</div>
			<div class='op_mod_qr_bottom'>
				<img class='op_mod_qr_bot_icon' src='@/assets/icon/qrcode.png' />
				<div class='op_mod_qr_bot_font font-14'>请使用微信或支付宝扫描二维码支付，未支付订单将不会安排生产</div>
			</div>
		</div>

		<img class='op_mod_banner' src='@/assets/banner/code_phone.png' />

		<div class='op_mod_btn no-copy'>
			<div class='op_mod_btn_view bgcolor-gradient-right font-16' @click='func_cancelPay'>暂不支付</div>
		</div>


		<!-- 转用预存款支付 -->
		<div v-if='canPay >= price' class='op_mod_otherPay'>
			<div class='op_mod_otp_font'>您的预存款余额，足以支付本次订单。您可以选用预存款支付。</div>
			<div class='op_mod_otp_btn bgcolor font-14 no-copy' 
				 @click='func_advencePay' 
				 >预存款支付
			</div>
		</div>

	</div>

</div>
</template>

<script>
import { req_orderDetail, req_orderChangePayMethod} from '@/services/order';
import {req_userInfo} from '@/services/user';

export default {
	name: 'onlinePay',
	components: {
	},
	data() {
		return {
			codeUrl: false,//支付码地址
			price: '',
			payed: false,//是否支付成功
			timerIDS: false,//监听器ID
			timerCount: 0,	//监听当前等待支付时间,
			fee: false,//是否是额外支付
			userinfo: false,
			canPay: -1,//可支配预存款余额
			orderIdArr: [],
		}
	},
	methods: {
		// 暂不支付
		func_cancelPay() {
			this.$router.push({
				name: 'orderManege'
			});
		},
		// ================================================================================================================================
		async func_getCode(orderId, total, feeId) {
			let url = ' http://pay.yin2015.com/qrcode/code?';

			const oneOid = orderId.split(',');
            
			if (orderId && total) {
				url = url + 'id=' + orderId + '&total=' + total + (feeId ? '&feeId='+feeId : '');
				this.codeUrl = url;
				this.func_listening(oneOid[0]);
			}
			console.log(url)
		},
		// 开启监听器
		async func_listening(orderId) {
			this.timerIDS = setInterval(() => {
				this.timerCount += 1;
				this.func_orderDetail(orderId);
				if (this.timerCount >= 900) {
					clearInterval(this.timerIDS);
				}
			}, 2000);
		},
		async func_orderDetail(orderId) {
			const result = await req_orderDetail(orderId);

			if (result.success) {

				//额外支付-判断条件
				if (this.fee) {
					if (result.data.needfee > 0) {
						//未支付
					} else {
						//已支付
						this.payed = true;
						this.STORAGE.remove('g_orderInfoEd');

						clearInterval(this.timerIDS);
						setTimeout(() => {
							this.$router.push({
								name: 'orderManege',
							});
						}, 2000)
					}

				} else {
					if (result.data.flag === 0) {
						//付款成功
						this.payed = true;
						this.STORAGE.remove('g_orderInfoEd');

						clearInterval(this.timerIDS);
						setTimeout(() => {
							this.$router.push({
								name: 'orderManege',
							});
						}, 2000)
					}
				}
			} else {
			}
		},
		// ================================================================================================================================
		async func_userinfo() {
			const userinfo = this.STORAGE.get('g_userInfo');
			const result = await req_userInfo(userinfo['userid']);
			if (result.success) {
				this.userinfo = result.data;
				this.canPay = parseInt(this.userinfo.quota) + parseInt(this.userinfo.moneys);
			}
		},
		// 预存款支付
		async func_advencePay() {
			this.$parent.loadingChange(true, '预存款支付中');
			let count = 0;
			for (let i in this.orderIdArr) {
				const result = await req_orderChangePayMethod(this.orderIdArr[i]);
				if (!result.success) {
					count += 1;
				}
			}
			this.$parent.loadingChange(false);
			if (count < 1) {
				// 全部订单转换支付方式成功
				this.$parent.confirmChange('information', '当前'+this.orderIdArr.length+'笔订单，已使用预存款支付。请稍等支付扣费结果', () => {
				}, () => {}, {yes:'知道了', no:''});
			} else {
				// 部分订单转换支付方式失败
				this.$parent.confirmChange('warning', '当前订单已使用预存款支付，其中'+count+'笔订单使用预存款支付失败。详情请稍后在订单管理中查看。', () => {
				}, () => {}, {yes:'知道了', no:''});
			}
		}
	},
	mounted() {
		//获取订单Id
		const params = this.STORAGE.get('g_orderInfoEd');
		if (params) {
			this.price = parseInt(params.total);
			if (params.feeId) {
				this.fee = true;
			}
			this.orderIdArr = params.orderId.toString().split(',');
			this.func_getCode(params.orderId.toString(), params.total, params.feeId);
			this.func_userinfo();
		}
	},
	destroyed() {
		clearInterval(this.timerIDS);
	}
}
</script>
<style src='@/style/onlinePay.css' scoped></style>



// WEBPACK FOOTER //
// src/pages/OnlinePay.vue